import React, {useEffect, useState} from "react";
import s from "./commandsMonths.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import useGetSearchParams from "../../../../../hooks/useGetSearchParams";
import useSetSearchParams from "../../../../../hooks/useSetSearchParams";
import {
    created_at_after
} from "../../../../Authorized/Statistics/IOS/IOSClicksStats/IOSClicksStats";
import CustomSkeleton from "../../../../../components/UiKit/CustomSkeleton/CustomSkeleton";
import {
    commandsWeeksColumnsList, params,
} from "../../../../../utils/vars/params";
import {useTranslation} from "react-i18next";
import {
    clientAnalyticsSelector, fetchTeamsMonthsAnalytics,
    resetMonthsDataLists,
} from "../../../../../redux/slices/clientAnalyticsSlice";
import {MuiDatePicker} from "../../../../../components/DatePickers/MuiDatePicker";
import {stringToDayJs} from "../../../../../utils/helpers/formatTime";
import dayjs from "dayjs";
import {getDataFromSelector} from "../../../../../utils/helpers/getDataFromSelector";
import {ANDROID} from "../../../../../utils/vars/staticVariables";


const monthsTables = [
    {
        state: 'androidDataMonth1List',
        created_at_after: null,
        created_at_before: null,
    },
    {
        state: 'androidDataMonth2List',
        created_at_after: null,
        created_at_before: null,
    },
    {
        state: 'androidDataMonth3List',
        created_at_after: null,
        created_at_before: null,
    },
    {
        state: 'androidDataMonth4List',
        created_at_after: null,
        created_at_before: null,
    },
]

const CommandsMonths = () => {
    const [monthsList, setMonthsList] = useState(monthsTables);

    const {
        androidDataMonthPending,
    } = useSelector(clientAnalyticsSelector);

    const clientAnalytics = useSelector(clientAnalyticsSelector);

    const dispatch = useDispatch();

    const [searchParams, setSearchParams] = useSearchParams();

    const {
        search: searchValue,
        created_at_after: createdAtAfterParam,
        tier: tierValue,
        content: contentValue
    } = useGetSearchParams();

    const updateSearchParams = useSetSearchParams(setSearchParams);

    const {t} = useTranslation();

    const fetchTablesData = async (updatedMonthsList) => {
        for (const week of updatedMonthsList) {

            const newParams = new URLSearchParams();
            newParams.set(params.created_at_after, week.created_at_after);
            newParams.set(params.created_at_before, week.created_at_before);
            if (searchValue) {
                newParams.set(params.user, searchValue)
            }
            if (tierValue) {
                newParams.set(params.tier, tierValue)
            }

            try {
                await dispatch(fetchTeamsMonthsAnalytics({os: ANDROID ,params: newParams, state: week.state}));
            } catch (error) {
                console.error("Error fetching data for week:", week.state, error);
            }
        }
    }

    const handleDateChange = (startDate) => {
        let previousEndDate = startDate;

        const updatedMonthsList = monthsList.map((week, index) => {
            let startOfMonth

            if (index === 0) {
                startOfMonth = startDate
            } else {
                startOfMonth = previousEndDate.add(1, "day");
            }

            const endOfMonth = startOfMonth.add(1, "month").startOf("day");

            previousEndDate = endOfMonth;

            return {
                ...week,
                created_at_after: startOfMonth.format("YYYY-MM-DD"),
                created_at_before: endOfMonth.format("YYYY-MM-DD"),
            };
        });

        setMonthsList(updatedMonthsList);

        updateSearchParams("created_at_after", startDate.format("YYYY-MM-DD"));
        fetchTablesData(updatedMonthsList);
    };


    useEffect(() => {
        return () => {
            dispatch(resetMonthsDataLists(ANDROID))
        }
    }, [dispatch]);

    useEffect(() => {
        if (createdAtAfterParam) {
            const parsedDate = dayjs(createdAtAfterParam, 'YYYY-MM-DD', true)

            if (parsedDate.isValid) {
                handleDateChange(parsedDate)
            } else {
                updateSearchParams(created_at_after, '', true)
            }
        }
    }, [createdAtAfterParam, searchValue, tierValue, contentValue])

    const handleSearchParams = (newStartDate) => {
        handleDateChange(newStartDate);
    };

    const calculateInstallChangePercent = (currentInstalls, nextInstalls) => {
        if (currentInstalls === 0) return nextInstalls > 0 ? 100 : 0;

        const change = ((nextInstalls - currentInstalls) / currentInstalls) * 100;
        return change.toFixed(2);
    };

    return (
        <div className={s.usersTableWrapper}>

            <div className={s.pageInnerContent}>

                <div className={s.tableContainer}>
                    {
                        monthsList.map((week, index) => {
                            const {data} = getDataFromSelector(clientAnalytics, week.state);
                            const previousWeek = monthsList[index - 1];

                            const {data: previousWeekData} = previousWeek ? getDataFromSelector(clientAnalytics, previousWeek.state) : {data: []};

                            return (
                                <section className={s.body} key={index}>
                                    <table>
                                        <thead>
                                        <tr>
                                            <th
                                                className={s.thDatePicker}
                                                colSpan="4"
                                            >
                                                <div className={s.datePickersWrapper}>
                                                    {
                                                        index === 0
                                                            ? <>
                                                                <div className={s.datePicker}>
                                                                    <MuiDatePicker
                                                                        label={t("date_from")}
                                                                        searchParamValue={created_at_after}
                                                                        greyTheme
                                                                        handler={handleSearchParams}
                                                                    />
                                                                </div>
                                                                <div className={s.datePicker}>
                                                                    <div className={s.dateContainer}>
                                                                        {t('to')}
                                                                        {' '}
                                                                        {week.created_at_before}
                                                                    </div>
                                                                </div>
                                                            </>
                                                            : <>
                                                                <div className={s.datePicker}>
                                                                    <div className={s.dateContainer}>
                                                                        {t('from')}
                                                                        {' '}
                                                                        {week.created_at_after}
                                                                    </div>
                                                                </div>
                                                                <div className={s.datePicker}>
                                                                    <div className={s.dateContainer}>
                                                                        {t('to')}
                                                                        {' '}
                                                                        {week.created_at_before}
                                                                    </div>
                                                                </div>

                                                            </>
                                                    }
                                                </div>
                                            </th>
                                        </tr>
                                        <tr>
                                            {
                                                commandsWeeksColumnsList.map(({name}, index) => <th
                                                    key={index}>{t(name)}</th>)
                                            }
                                        </tr>
                                        </thead>

                                        <tbody>

                                        {
                                            androidDataMonthPending
                                                ? <tr>
                                                    <td colSpan='4'>
                                                        <div className={s.skeletonWrapper}>
                                                            <CustomSkeleton styles={s.skeletonTable}/>
                                                        </div>
                                                    </td>
                                                </tr>
                                                : data.length > 0
                                                    ? data.map(({color, installs, user, top_user}) => {

                                                        const previousWeekInstalls = previousWeekData.find(item => item.user === user)?.installs

                                                        const installsChange = previousWeekInstalls ? calculateInstallChangePercent(previousWeekInstalls, installs) : null;

                                                        return (
                                                            <tr key={user}>
                                                                <td className={s[color]}>{top_user}</td>
                                                                <td className={s[color]}>{user}</td>
                                                                <td className={`
                                                                ${installs < 500 ? s.grey : ''}
                                                                ${installs >= 500 && installs < 2000 ? s.orange : ''}
                                                                ${installs >= 2000 && installs < 10000 ? s.yellow : ''}
                                                                ${installs >= 10000 ? s.green : ''}
                                                            `}>{installs}</td>
                                                                <td className={`
                                                                ${installsChange > 0 ? s.green : ''}
                                                                ${installsChange < 0 ? s.red : ''}
                                                                ${installsChange === 0 ? s.orange : ''}
                                                            `}>
                                                                    {previousWeekInstalls && installsChange !== null && (
                                                                        <span>{installsChange}%</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    : <tr>
                                                        <td
                                                            colSpan="4"
                                                        >
                                                            <div className={s.noRecords}>{t("records_not_found")}</div>
                                                        </td>
                                                    </tr>

                                        }
                                        </tbody>
                                    </table>
                                </section>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default CommandsMonths;
